import {
  LayoutDashboard, Users, Calendar, CalendarDays, LogOut, ChevronDown,
  ClipboardList, FolderTree, FileCheck, PieChart, UserX, CalendarCheck,
  DoorOpen, FileText, Clock, ClipboardCheck, FileEdit, CalendarHeart,
  UserPlus, UserCircle, Building2, Settings, Newspaper, Send, ShieldCheck,
  Wrench, BellRing, Car, ShieldAlert, Trash2, BookUser, GraduationCap, Briefcase, Target, Sparkles, Mail, BarChart3,
} from 'lucide-react';

// permArea + permLevel: Navigation items are shown if user has at least permLevel for permArea
export const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/mein-profil', label: 'Mein Profil', icon: UserCircle },
  { path: '/zeiterfassung', label: 'Zeiterfassung', icon: Clock },
  { path: '/news', label: 'Neuigkeiten', icon: Newspaper, permArea: 'news', permLevel: 'view' },
  { path: '/qmb', label: 'QMB / Qualitätsmanagement', icon: ShieldCheck },
  { path: '/telefonbuch', label: 'Telefonbuch', icon: BookUser },
  { path: '/stellenausschreibungen', label: 'Stellenausschreibungen', icon: FileEdit, permArea: 'job_postings', permLevel: 'view' },
  { path: '/recruiting', label: 'Bewerber / Recruiting', icon: UserPlus, permArea: 'job_postings', permLevel: 'view' },
  { path: '/employees', label: 'Mitarbeiter', icon: Users, permArea: 'employees', permLevel: 'view' },
  { path: '/personalanalyse', label: 'Personalanalyse', icon: BarChart3, permArea: 'employees', permLevel: 'view' },
  { path: '/honorarkraefte', label: 'Honorarkräfte', icon: Briefcase, permArea: 'employees', permLevel: 'view' },
  { path: '/workflows', label: 'Workflows', icon: UserPlus, permArea: 'employees', permLevel: 'view' },
  { path: '/aenderungsantraege', label: 'Änderungsanträge', icon: FileText, permArea: 'employees', permLevel: 'view' },
  { path: '/qualifikations-antraege', label: 'Qualifikations-Anträge', icon: GraduationCap, permArea: 'employees', permLevel: 'edit' },
  { path: '/organization', label: 'Organisation', icon: FolderTree, permArea: 'settings', permLevel: 'edit' },
  { path: '/compliance', label: 'Compliance', icon: FileCheck, permArea: 'compliance', permLevel: 'view' },
  { path: '/urlaub', label: 'Urlaub & Abwesenheit', icon: Calendar },
  { path: '/vacation-balance', label: 'Urlaubsübersicht', icon: PieChart, permArea: 'vacations', permLevel: 'view' },
  { path: '/absences', label: 'Abwesenheiten', icon: UserX, permArea: 'absences', permLevel: 'view' },
  { path: '/einsatzplan', label: 'Einsatzplan', icon: CalendarDays },
  { path: '/shifts', label: 'Einsatzplanung', icon: CalendarDays, permArea: 'shifts', permLevel: 'view' },
  { path: '/massnahmen', label: 'Maßnahmen', icon: Target, permArea: 'shifts', permLevel: 'edit' },
  { path: '/personaleinsatz', label: 'Personaleinsatz', icon: ClipboardCheck, permArea: 'shifts', permLevel: 'edit' },
  { path: '/rooms', label: 'Raumverwaltung', icon: DoorOpen, permArea: 'rooms', permLevel: 'edit' },
  { path: '/raumbuchung', label: 'Raumbuchung', icon: DoorOpen },
  { path: '/reinigung', label: 'Reinigung / Putzplan', icon: Sparkles, permArea: 'rooms', permLevel: 'view' },
  { path: '/fuhrpark', label: 'Fuhrpark', icon: Car, permArea: 'fleet', permLevel: 'view' },
  { path: '/fahrzeugbuchung', label: 'Fahrzeugbuchung', icon: Car },
  { path: '/haustechnik', label: 'Haustechnik', icon: Wrench, permArea: 'facility', permLevel: 'view' },
  { path: '/requests', label: 'Antragstellung', icon: Send },
  { path: '/templates', label: 'Dokumentvorlagen', icon: FileText, permArea: 'documents', permLevel: 'view' },
  // Urlaubsanträge entfernt — jetzt als Tab in /urlaub
  { path: '/company-settings', label: 'Firma', icon: Building2, permArea: 'settings', permLevel: 'edit' },
  { path: '/it-einstellungen', label: 'IT-Einstellungen', icon: Wrench, permArea: 'settings', permLevel: 'edit' },
  { path: '/permissions', label: 'Rechtevergabe', icon: Settings, adminOnly: true },
  { path: '/admin/trash', label: 'Papierkorb', icon: Trash2, adminOnly: true },
];

export { LogOut, ChevronDown, Settings };
